import { create } from 'zustand';
import type { User } from '@vipsoft/shared-types';

/**
 * Store de sesión activa (access_token + user). NO persiste — el access vive
 * solo en memoria para mitigar XSS. El refresh token está en cookie HttpOnly
 * que se renueva automáticamente vía /auth/refresh cuando hay un 401.
 *
 * Si el usuario recarga la página y la cookie sigue vigente, App.tsx llama
 * /auth/refresh en mount y restaura la sesión sin pedir credenciales.
 */

export interface AuthState {
  accessToken: string | null;
  user: Pick<User, 'id' | 'email' | 'name' | 'role'> | null;
  setSession: (token: string, user: AuthState['user']) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setSession: (accessToken, user) => set({ accessToken, user }),
  clear: () => set({ accessToken: null, user: null }),
}));
